import * as React from 'react';
import SuperCritical from 'lib/supercritical';

export const 
    PCBadge = SuperCritical(({ visible, className, onClick, children } : { visible : boolean, className? : string, onClick? : () => void, children? : any }) =>
        <div className={"pc-badge " 
            + (visible ? 'pc-badge-visible ' : '') 
            + (onClick ? 'pc-badge-has-click ' : '')
            + (className || '') 
            } 
            onClick={onClick}
        >
            {children}
        </div>);


// WEBPACK FOOTER //
// ./apps/portcall/pcbadge/view.tsx